import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01e1ed50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redeem-info local-main-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverdueDetail = _resolveComponent("OverdueDetail")!
  const _component_FlowEdit = _resolveComponent("FlowEdit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.overdueRecordId)
      ? (_openBlock(), _createBlock(_component_OverdueDetail, {
          key: 0,
          id: _ctx.overdueRecordId,
          module: ['contract', 'customer', 'vehicle', 'overdue', 'collection', 'letter']
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_FlowEdit, {
      ref: "flow-edit",
      mainData: _ctx.mainData,
      flow: _ctx.flow.data,
      disabled: _ctx.isFinished,
      payload: { id: _ctx.currentParams.overdueRecordOrFlowId },
      onBack: _ctx.onBack
    }, null, 8, ["mainData", "flow", "disabled", "payload", "onBack"])
  ]))
}